import { FileAttachment } from "../../shared/models/file-attachment.model";
import { User } from "../../shared/models/user.model";

export class Section {
    SectionId: number;
    SectionName: string;
}
export class Task {
    TaskId: number = 0;
    SectionId: number;
    Name: string;
    TaskDescription: string;
    RecurrencePeriod: string;
    RecurrenceTask: number;
    DayNumber: number = 1;
    TaskFileDescription: FileAttachment[] = [];
    TaskOwner: number;
    TaskPrewarningDays: number = 1;
    isNewTask: boolean = true;
    Multiplier: number = 1;
    RecurrenceDate: Date;
    IsActive: boolean = true;
    UserId: number;
    TaskOwnerUser: User;
    Dates: Date[] = [];
    MatrixId: string;
    ActionOwner: User = new User();
    ActionParty: User = new User();
    ActionVerifier: User = new User();
    ActionOwnerId: number;
    ActionPartyId: number;
    ActionVerifierId: number;
    MatrixStartDate: Date;
    UnitId: number;
    Status: string;
    IsDraft: boolean = false;
    ContractId : number;
}
export class Guide {
    category: string;
    toCategory: string;
    LineAlpha: number = 0.5;
    expand: boolean = true;
    label: string;
    position: string = "left";
    tickLength: number = 50;
    labelOffset: number = 100;
}
export class Segment {
    start: Date;
    end: Date;
    color: string;
    task: string;
    SectionId: number;
    SectionName: string;
    Status: string;
    TaskId: number;
    ActionId: number;
    ClosedDate: string;
    ActionOwner: string;
    ActionParty: string;
    ActionVerifier: string;
    DueDate: string;
    labelColor: string;
    label: string;
    Report: string;
    forceShow: boolean = true;
    RecurrencePeriod: string;
    OriginalSectionName: string;
}
export class Category {
    category: string;
    segments: Segment[] = [];
}
